"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deviceSizeReducer = exports.layerVisibilityReducer = exports.mapViewReducer = void 0;

var _actions = require("kmap-redux/dist/actions");

var _mapActions = require("../actions/mapActions");

var _map = _interopRequireDefault(require("../config/map"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getInitialMapState = function getInitialMapState() {
  var initialView = _map.default.initialView;
  var viewRaw = window.localStorage.getItem('mapview');

  if (viewRaw) {
    var view = JSON.parse(viewRaw);

    if (view.center && view.center.lat && view.center.lng && view.zoom) {
      initialView = view;
    }
  }

  return {
    mapView: initialView
  };
};

var mapViewReducer = function mapViewReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialMapState();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _mapActions.VIEW_CHANGED:
      window.localStorage.setItem('mapview', JSON.stringify(action.view));
      return Object.assign({}, _objectSpread(_objectSpread({}, state), {}, {
        mapView: action.view
      }));

    default:
      return state;
  }
};

exports.mapViewReducer = mapViewReducer;

var layerVisibilityReducer = function layerVisibilityReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    activeLayer: _map.default.defaultLayer
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var nextState = Object.assign({}, _objectSpread(_objectSpread({}, state), {}, {
    activeLayer: state.activeLayer
  }));

  switch (action.type) {
    case _actions.SET_LAYER_VISIBILITY:
      if (action.visible && !nextState.activeLayer.includes(action.layerName)) {
        nextState.activeLayer.push(action.layerName);
        return nextState;
      }

      if (!action.visible && nextState.activeLayer.includes(action.layerName)) {
        nextState.activeLayer = nextState.activeLayer.filter(function (layer) {
          return layer !== action.layerName;
        });
        return nextState;
      }

      return state;

    default:
      return state;
  }
};

exports.layerVisibilityReducer = layerVisibilityReducer;

var deviceSizeReducer = function deviceSizeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    deviceSize: 'mobile'
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _mapActions.DEVICE_CHANGED:
      return Object.assign({}, _objectSpread(_objectSpread({}, state), {}, {
        deviceSize: action.nextDevice
      }));

    default:
      return state;
  }
};

exports.deviceSizeReducer = deviceSizeReducer;